module.exports = __webpack_public_path__ + "static/media/android_big.8f2fa0d6.png";